import {CssBaseline, makeStyles, useMediaQuery, useTheme} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import { HashRouter } from 'react-router-dom';
import HeaderBar from './HeaderBar';
import MainContent from './MainContent/MainContent';
import NavigationBar from './NavigationBar';
import {authRepository} from "../Domain/Repositories/AuthRepository";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
}));

export default function RootComponent()
{
  const classes = useStyles();
  const theme = useTheme();
  const showNavBarButton = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [navBarOpen, setNavBarOpen] = useState(true);
  
  const handleNavBarToggle = () =>
  {
      setNavBarOpen(!navBarOpen);
  }

  useEffect(() => {
    authRepository.load();
  }, []);

  return (
    <div className={classes.root}>
      <HashRouter>
        <CssBaseline />
        <HeaderBar
            showNavBarButton={showNavBarButton}
            navBarIsOpen={navBarOpen || !showNavBarButton}
            onToggleNavBar={handleNavBarToggle}
        />
        { (navBarOpen || !showNavBarButton) && <NavigationBar /> }
        <MainContent />
      </HashRouter>
    </div>
  );
}